import React from 'react';
import styled from 'styled-components'

const UL = styled.ul`
	margin: 0;
	padding: 0;
	display: flex;
	flex-wrap: wrap;
`

const LI = styled.li`
	margin-right: 32px;
	margin-bottom: 32px;
	cursor: pointer;
	display: inline-flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 22px 32px;
	width: 19%;
	background: #FFFFFF;
	box-shadow: 0px 0px 25px rgb(0 0 0 / 7%);
	border-radius: 2px;
    width: 250px;
    
    &:hover {
        box-shadow: 0px 0px 1px 1px #4361ee;
        color: #4361ee;
    }
`

const SquareSelect = ({ selected, options, onChange }) => {
    return (
        <UL>
            {options.map(choice => {
                return (
                    <LI key={choice.id} active={choice.id === selected ? true : false} onClick={(event) => {
                        onChange(choice);
                    }}>
                        {choice.title}
                    </LI>
                )
            })}
        </UL>
    )
}

export default SquareSelect;
